module.exports = "<ng-template #content let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"row\">\n    <app-info-panel [productArray]=\"productArray\" [isProduct]=\"isProduct\" #infoPanel></app-info-panel>\n  </div>\n  <div class=\"clearfix\"></div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-dark close_popup\" (click)=\"c('Close click')\">x</button>\n  </div>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/verify-product-modal/verify-product-modal.component.html
// module id = ../../../../../src/app/components/verify-product-modal/verify-product-modal.component.html
// module chunks = main